// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "@atlaskit-internal_dynamic-table" + "." + "7082fc8b" + ".chunk.js";
};